import { IUpdateInspecaoObraAprovacaoLoteUseCase } from "../../../presentation/useCases/update/update_inspecao_obra_aprovacao_lote_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * UpdateInspecaoObraAprovacaoLoteUseCase
 */

export class UpdateInspecaoObraAprovacaoLoteUseCase implements IUpdateInspecaoObraAprovacaoLoteUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async updateInspecaoObraAprovacaoLote(
    idFuncionario: number,
    inspecaoObraModels: Set<string | number>,
    dataAprovacao: Date,
  ): Promise<void> {
    const idsInspecaoObra = Array.from(inspecaoObraModels).map(x => {
      if (typeof x === 'string') {
        return Number(x);
      }
      if (typeof x === 'number') {
        return x;
      }
      throw new Error('Id inspeção obra invalido!');
    });

    await this.repository.updateInspecaoObraAprovacaoLote(
      idFuncionario,
      idsInspecaoObra,
      dataAprovacao,
    );
  }
}
